import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { InvestorProfileData } from "../../../components/Models/InvestorProfileData";

type UpdateInvestorDto = Partial<InvestorProfileData>;

export const useSaveInvestor = (
  options?: UseMutationOptions<
    InvestorProfileData,
    unknown,
    InvestorProfileData | UpdateInvestorDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<InvestorProfileData> | FormData) => {
      const isFormData = data instanceof FormData;

      // Determine if it's an update or create operation
      const hasId = isFormData
        ? data.get("id") ?? null
        : (data as Partial<InvestorProfileData>).id ?? null;

      // Set headers for FormData
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/MuslimInvestProfile/Investor/Update`), data, config)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/MuslimInvestProfile/Investor/Create"), data, config)
          .then((res) => res.data);
      }
    },
  });
};
